import { SfSelectOption } from 'ngx-smart-form';
import {
  ProfessionistaQualificaEnum,
  SezioneAtecoEnum,
} from 'src/app/applicant/models/professionista-record';
import { PersonaGiuridica } from './persona-giuridica';
import { AddressFormData } from '../../_widgets/address-form/address-form-data';

export type LiberoProfessionista = PersonaGiuridica & {
  annoRilevazioneDipendenti: string;
  codiceAteco: string;
  cognome: string;
  confermaPec: string;
  dataIscrizioneAlbo: Date;
  iscrizioneAlbo: string;
  nome: string;
  numeroIscrizioneAlbo: string;

  settoreAttivita: string;
  situazioneAbitativa: SituazioneAbitativaEnum;
  affitto: string;
  sezioneAteco: SezioneAtecoEnum;

  professione: ProfessioneEnum;

  location: AddressFormData;

  sae: string;
};

export enum StatoCivileEnum {
  CELIBENUBILE = 'Celibe/Nubile',
  CONIUGATO = 'Coniugato',
  DIVORZIATOSEPARATO = 'Divorziato/Separato',
  VEDOVO = 'Vedovo',
  ALTRO = 'Altro',
}

export enum SituazioneAbitativaEnum {
  PROPRIETA = 'Proprieta',
  AFFITTO = 'Affitto',
  PRESSOTERZI = 'Presso terzi',
  ATITOLOGRATUITO = 'A titolo gratuito',
  USUFRUTTO = 'Usufrutto',
}

export enum ProfessioneEnum {
  AVVOCATICOMMERCIALISTI = 'Avvocati, Commercialisti',
  CONSULENTI = 'Consulenti Aziendali',
  NOTAI = 'Notai',
  GEOMETRIRAGIONERI = 'Geometri, Ragionieri, Periti, Consulenti',
  INGERGNERIARCHITETTI = 'Ingegneri, Architetti',
  MEDICI = 'Medici',
  AGENTIASSICURAZIONE = 'Agenti Assicurazione',
}

export enum TipoContrattoLavoroEnum {
  INDETERMINATO = 'Lavoratore Dipendente a Tempo Indeterminato',
  DETERMINATO = 'Lavoratore Dipendente a Tempo Determinato',
  APPRENDISTATO = 'Apprendistato',
  INSERIMENTO = 'Contratto di Inserimento',
  COLLABORAZIONE = 'Collaborazione a Progetto',
  LIBEROPROFESSIONISTA = 'Lavoratore Autonomo / Libero Professionista',
  LAVOROOCCASIONALE = 'Lavoro Occasionale / Accessorio / Intermittente',
  TIROCINIO = 'Tirocinio / stage',
  NONCONOSCIUTO = 'Dato non conosciuto',
}

export const getSelectOptions = (optionsObject: object) => {
  return Object.values(optionsObject).map(
    (el) =>
      <SfSelectOption>{
        value: el,
        view: el.toUpperCase(),
      }
  );
};
